import { useEffect, useRef } from 'react';
import { toaster } from 'toasterhea';
export const Popup = toaster();
export function useBoundingClientRectEffect({ anchorRef, translateFn, onUpdate, deps = [], }) {
    const onUpdateRef = useRef(onUpdate);
    if (onUpdateRef.current !== onUpdate) {
        onUpdateRef.current = onUpdate;
    }
    useEffect(() => {
        if (!anchorRef) {
            return () => { };
        }
        function update() {
            onUpdateRef.current?.(translateFn
                ? translateFn(anchorRef?.current?.getBoundingClientRect())
                : { x: 0, y: 0, width: 0, height: 0 });
        }
        update();
        window.addEventListener('resize', update);
        window.addEventListener('scroll', update);
        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('scroll', update);
        };
    }, [anchorRef, translateFn, ...deps]);
}
export function createTranslateFn([vPos, hPos]) {
    return (rect) => {
        const { x: X = 0, y: Y = 0, width = 0, height = 0 } = rect || {};
        let x = X;
        if (hPos === 'center') {
            x += width / 2;
        }
        else if (hPos === 'right') {
            x += width;
        }
        let y = Y;
        if (vPos === 'center') {
            y += height / 2;
        }
        else if (vPos === 'bottom') {
            y += height;
        }
        return { x, y, width, height };
    };
}
export const BottomCenter = createTranslateFn(['bottom', 'center']);
export const TopCenter = createTranslateFn(['top', 'center']);
export const BottomRight = createTranslateFn(['bottom', 'right']);
export const TopRight = createTranslateFn(['top', 'right']);
export const BottomLeft = createTranslateFn(['bottom', 'left']);
export const TopLeft = createTranslateFn(['top', 'left']);
export const CenterRight = createTranslateFn(['center', 'right']);
